module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_inomemado-8614f12fa1dbe7038c558bc50ca12fb5.jpg";